import {useState, useEffect, useRef} from "react";
import {Link, useLocation} from "react-router-dom";
import {Swiper, SwiperSlide} from "swiper/react";
import {Autoplay} from "swiper/modules";
import {success, error} from "../Global/toast";
import clsx from "clsx";
import APICallService from "../api/apiCallService";
import {ADD_LEAD, CONTACTUS, FAQ} from "../api/apiEndPoints";
import {
    CUSTOMER_APP_STORE_URL,
    CUSTOMER_GOOGLE_PLAY_URL,
    DRIVER_APP_STORE_URL,
    DRIVER_GOOGLE_PLAY_URL,
} from "../utils/constants";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Main_img from "../assets/media/main-img.webp";
import GooglePlaySVG from "../assets/media/google-play.svg";
import AppStoreSvg from "../assets/media/app-store.svg";
import LogoDark from "../assets/media/LogoDark.svg";
import EmissionSvg from "../assets/media/emission-calculation-icon.svg";
import CarbonMeterSvg from "../assets/media/carbon-credit-meter-icon.svg";
import TravelReductionSvg from "../assets/media/travel-reduction-icon.svg";
// import StarIcon from "../assets/media/star.svg";
import ChatIcon from "../assets/media/chat-icon.svg";
import Mail from "../assets/media/mail.svg";
import FastReliableIcon from "../assets/media/fast-reliable-icon.svg";
import EasyDeliveryIcon from "../assets/media/easy-delivery-icon.svg";
import RealTimeTrackingIcon from "../assets/media/real-time-tracking-icon.svg";
import SmartPriceIcon from "../assets/media/smart-price-icon.svg";
import SmartJobIcon from "../assets/media/smart-job-icon.svg";
import RouteOptimizationIcon from "../assets/media/route-optimization-icon.svg";
import ArrowRight from "../assets/media/arrow-right.svg";
import MobileView from "../assets/media/mobile-view.webp";
import AboutImg from "../assets/media/about-img.webp";
import LaurenM from "../assets/media/testimonials/lauren-m.webp";
import DavidB from "../assets/media/testimonials/david-b.webp";
import MapImg from "../assets/media/map.webp";
import MapMobileImg from "../assets/media/map-mobile.webp";
import HowWork1 from "../assets/media/how-work-1.webp";
import HowWork2 from "../assets/media/how-work-2.webp";
import HowWork3 from "../assets/media/how-work-3.webp";
import HowWork4 from "../assets/media/how-work-4.webp";
import HowWork5 from "../assets/media/how-work-5.webp";
import CustomSelectWhite from "../components/customSelectWhite";
import PhoneInputWhite from "../components/phoneInputWhite";

const insuranceOptions = [
    {value: "1", label: "Commercial Insurance"},
    {value: "2", label: "Private Insurance"},
];

export const FeaturesData = [
    {
        id: 0,
        img: EasyDeliveryIcon,
        title: "Easy Delivery Requests",
        subtitle: "Post your delivery details in seconds, add pickup, drop-off, and package info with just a few taps.",
    },
    {
        id: 1,
        img: RealTimeTrackingIcon,
        title: "Real-Time Tracking",
        subtitle: "Track your delivery live and get instant updates from pickup to drop-off.",
    },
    {
        id: 2,
        img: SmartPriceIcon,
        title: "Smart Price Bargaining",
        subtitle:
            "Negotiate delivery rates with drivers before confirming request, get the best deal for your delivery.",
    },
    {
        id: 3,
        img: SmartJobIcon,
        title: "Smart Job Matching",
        subtitle:
            "Receive delivery requests that fit your current route, saving time and fuel while maximizing efficiency.",
    },
    {
        id: 4,
        img: RouteOptimizationIcon,
        title: "Route Optimization",
        subtitle: "Get the most efficient navigation suggestions to complete more jobs in less time.",
    },
    {
        id: 5,
        img: FastReliableIcon,
        title: "Fast & Reliable Payouts",
        subtitle: "Get paid quickly and securely after each completed delivery, straight to your wallet or bank.",
    },
];
export const howItWorksSlides = [
    {
        id: 1,
        image: HowWork1,
        title: "Post your job",
        desc: "Easily schedule your pickup and drop-off with just a few taps!",
    },
    {
        id: 2,
        image: HowWork2,
        title: "Hitch finds a verified driver already going your way.",
        desc: "Connect instantly with verified drivers traveling the same way.",
    },
    {
        id: 3,
        image: HowWork3,
        title: "Receive offers and negotiate via In-App Chat.",
        desc: "Get instant offers from verified drivers.Chat directly to negotiate and confirm your ride.",
    },
    {
        id: 4,
        image: HowWork4,
        title: "Agree & Confirm details",
        desc: "Double-check pickup, drop-off, and fare.Confirm when everything looks good.",
    },
    {
        id: 5,
        image: HowWork5,
        title: "Track and pay securely in the app",
        desc: "Real-time tracking, hassle-free payments.Everything you need — all in one app.",
    },
];
export const TestimonialData = [
    {
        name: "Lauren M.",
        rating: 5,
        image: LaurenM,
        review: "Hitch is very reliable. They handled two moves for me without any hassle. The team is always polite and punctual.",
    },
    {
        name: "David B.",
        rating: 5,
        image: DavidB,
        review: "The app boasts a clean, intuitive interface that simplifies the logistics process.Users are guided through each step with clear prompts and easy navigation.",
    },
];
interface FormData {
    name: string;
    email: string;
    message: string;
}
interface validationErrors {
    name: boolean;
    email: boolean;
    message: boolean;
}
interface RegisterInterestFormData {
    fullName: string;
    email: string;
    phone: string;
    phoneCountry: string;
    dateOfBirth: string;
    county: string;
    occupation: string;
    insurance: string;
    additionalInfo: string;
}

const getNationalPhoneNumber = (fullPhone: string, dialCode: string) => {
    const digits = fullPhone.replace(/\D/g, "");
    const code = dialCode.replace(/\D/g, "");

    if (code && digits.startsWith(code)) {
        return digits.slice(code.length);
    }

    return digits;
};
interface RegisterInterestValidationErrors {
    fullName: boolean;
    email: boolean;
    phone: boolean;
    dateOfBirth: boolean;
    county: boolean;
    occupation: boolean;
    insurance: boolean;
}
interface FAQItem {
    title: string;
    userType: number;
    content: string;
}
const Home = () => {
    const location = useLocation();

    const initialState = {
        name: "",
        email: "",
        message: "",
    };

    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState<FormData | any>(initialState);
    const [customerFAQs, setCustomerFAQs] = useState<FAQItem[]>([]);
    const [driverFAQs, setDriverFAQs] = useState<FAQItem[]>([]);
    const [faqLoading, setFaqLoading] = useState(true);
    const faqFetchedRef = useRef(false);
    const [recaptchaToken, setRecaptchaToken] = useState<string | null>(null);
    const recaptchaRef = useRef<HTMLDivElement>(null);
    const recaptchaWidgetId = useRef<number | null>(null);
    const recaptchaRenderedRef = useRef<boolean>(false);
    const registerInterestInitialState: RegisterInterestFormData = {
        fullName: "",
        email: "",
        phone: "",
        phoneCountry: "353",
        dateOfBirth: "",
        county: "",
        occupation: "",
        insurance: "",
        additionalInfo: "",
    };

    const [registerInterestData, setRegisterInterestData] =
        useState<RegisterInterestFormData>(registerInterestInitialState);
    const [registerInterestErrors, setRegisterInterestErrors] = useState<RegisterInterestValidationErrors>({
        fullName: false,
        email: false,
        phone: false,
        dateOfBirth: false,
        county: false,
        occupation: false,
        insurance: false,
    });
    const [registerInterestLoading, setRegisterInterestLoading] = useState(false);

    const [validationErrors, setValidationErrors] = useState<validationErrors>({
        name: false,
        email: false,
        message: false,
    });

    const handleScrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
        e.preventDefault();

        if (location.pathname !== "/") {
            window.location.href = `/#${sectionId}`;
        } else {
            // Smooth scroll to section
            const element = document.getElementById(sectionId);
            if (element) {
                const headerOffset = 0;
                const elementPosition = element.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth",
                });
            }
        }
    };

    useEffect(() => {
        setValidationErrors({
            name: false,
            email: false,
            message: false,
        });
    }, [location.pathname]);

    useEffect(() => {
        (window as any).onRecaptchaSuccess = (token: string) => {
            setRecaptchaToken(token);
        };

        (window as any).onRecaptchaError = () => {
            setRecaptchaToken(null);
        };

        (window as any).onRecaptchaExpired = () => {
            setRecaptchaToken(null);
        };

        const renderRecaptcha = () => {
            if (recaptchaRenderedRef.current) {
                return;
            }
            if (recaptchaRef.current && (window as any).grecaptcha && (window as any).grecaptcha.render) {
                if (recaptchaWidgetId.current !== null) {
                    return;
                }
                if (recaptchaRef.current.children.length > 0) {
                    recaptchaRenderedRef.current = true;
                    return;
                }
                try {
                    recaptchaWidgetId.current = (window as any).grecaptcha.render(recaptchaRef.current, {
                        sitekey: "6Lemrh8sAAAAALg4miyU4pczrrhZEKpxQnfYeOr-",
                        // size: "compact",
                        callback: (token: string) => {
                            setRecaptchaToken(token);
                        },
                        "expired-callback": () => {
                            setRecaptchaToken(null);
                        },
                        "error-callback": () => {
                            setRecaptchaToken(null);
                        },
                    });
                    recaptchaRenderedRef.current = true;
                } catch (error) {
                    console.error("Error rendering reCAPTCHA:", error);
                }
            }
        };

        if ((window as any).grecaptcha && (window as any).grecaptcha.render) {
            renderRecaptcha();
        } else {
            const checkRecaptcha = setInterval(() => {
                if ((window as any).grecaptcha && (window as any).grecaptcha.render) {
                    clearInterval(checkRecaptcha);
                    renderRecaptcha();
                }
            }, 100);
            setTimeout(() => {
                clearInterval(checkRecaptcha);
            }, 10000);
        }

        return () => {
            if (recaptchaWidgetId.current !== null && (window as any).grecaptcha) {
                try {
                    (window as any).grecaptcha.reset(recaptchaWidgetId.current);
                } catch (e) {}
            }
            delete (window as any).onRecaptchaSuccess;
            delete (window as any).onRecaptchaError;
            delete (window as any).onRecaptchaExpired;
        };
    }, []);

    useEffect(() => {
        if (faqFetchedRef.current) return;

        const fetchFAQs = async () => {
            try {
                faqFetchedRef.current = true;
                setFaqLoading(true);
                const apiService = new APICallService(FAQ, {});
                const response = await apiService.callAPI();

                if (response) {
                    let parsedResponse = response;
                    if (typeof response === "string") {
                        try {
                            parsedResponse = JSON.parse(response);
                        } catch (e) {
                            return;
                        }
                    }

                    const records = parsedResponse.records || [];

                    if (Array.isArray(records) && records.length > 0) {
                        const customerFAQsData = records.filter((item: FAQItem) => item.userType === 2);
                        const driverFAQsData = records.filter((item: FAQItem) => item.userType === 3);
                        setCustomerFAQs(customerFAQsData);
                        setDriverFAQs(driverFAQsData);
                    }
                }
            } catch (error) {
                faqFetchedRef.current = false;
                console.error("FAQ API Error:", error);
            } finally {
                setFaqLoading(false);
            }
        };

        fetchFAQs();
    }, []);

    const handleInputChange = (value: string, field: keyof FormData) => {
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        const nameRegex = /^[a-zA-Z\s]+$/;

        let isInvalid = false;
        if (field === "name") {
            isInvalid = value.trim().length === 0 || !nameRegex.test(value.trim());
        } else if (field === "email") {
            isInvalid = value.trim().length === 0 || !emailRegex.test(value.trim());
        } else {
            isInvalid = value.trim().length === 0;
        }

        setValidationErrors((prev) => ({
            ...prev,
            [field]: isInvalid,
        }));

        setFormData((prev: FormData) => ({
            ...prev,
            [field]: value,
        }));
    };

    const validateRegisterInterestField = (field: keyof RegisterInterestFormData, value: string): boolean => {
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        const trimmed = value.trim();

        switch (field) {
            case "additionalInfo":
                return false;
            case "email":
                return trimmed.length === 0 || !emailRegex.test(trimmed);
            default:
                return trimmed.length === 0;
        }
    };

    const validateRegisterInterestPhone = (phone: string, phoneCountry: string) => {
        const nationalNumber = getNationalPhoneNumber(phone, phoneCountry);
        if (nationalNumber.length === 0) return true;
        return nationalNumber.length < 7 || nationalNumber.length > 12;
    };

    const handleRegisterInterestChange = (value: string, field: keyof RegisterInterestFormData) => {
        const nextValue = value.trimStart();

        setRegisterInterestData((prev) => ({
            ...prev,
            [field]: nextValue,
        }));

        if (field !== "additionalInfo") {
            setRegisterInterestErrors((prev) => ({
                ...prev,
                [field]: validateRegisterInterestField(field, nextValue),
            }));
        }
    };

    const handleRegisterInterestPhoneChange = (phone: string, dialCode: string) => {
        setRegisterInterestData((prev) => ({
            ...prev,
            phone,
            phoneCountry: dialCode,
        }));

        const nationalNumber = getNationalPhoneNumber(phone, dialCode);
        if (nationalNumber.length >= 7 && nationalNumber.length <= 12) {
            setRegisterInterestErrors((prev) => ({...prev, phone: false}));
        }
    };

    const handleRegisterInterestSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        const errors: RegisterInterestValidationErrors = {
            fullName: validateRegisterInterestField("fullName", registerInterestData.fullName),
            email: validateRegisterInterestField("email", registerInterestData.email),
            phone: validateRegisterInterestPhone(registerInterestData.phone, registerInterestData.phoneCountry),
            dateOfBirth: validateRegisterInterestField("dateOfBirth", registerInterestData.dateOfBirth),
            county: validateRegisterInterestField("county", registerInterestData.county),
            occupation: validateRegisterInterestField("occupation", registerInterestData.occupation),
            insurance: validateRegisterInterestField("insurance", registerInterestData.insurance),
        };

        setRegisterInterestErrors(errors);

        const isValid = Object.values(errors).every((error) => !error);
        if (!isValid) return;

        setRegisterInterestLoading(true);

        const payload = {
            name: registerInterestData.fullName.trim(),
            email: registerInterestData.email.trim(),
            phoneCountry: registerInterestData.phoneCountry.replace(/\D/g, ""),
            phone: getNationalPhoneNumber(registerInterestData.phone, registerInterestData.phoneCountry),
            dob: registerInterestData.dateOfBirth,
            address: registerInterestData.county.trim(),
            occupation: registerInterestData.occupation.trim(),
            county: registerInterestData.county.trim(),
            insurance: Number(registerInterestData.insurance),
            info: registerInterestData.additionalInfo.trim(),
        };

        const apiService = new APICallService(ADD_LEAD, payload);
        const response = await apiService.callAPI();

        if (response) {
            success("Thank you for your interest. We will get back to you soon.");
            setRegisterInterestData(registerInterestInitialState);
            setRegisterInterestErrors({
                fullName: false,
                email: false,
                phone: false,
                dateOfBirth: false,
                county: false,
                occupation: false,
                insurance: false,
            });
        }

        setRegisterInterestLoading(false);
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        const {name, email, message} = formData;
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        const nameRegex = /^[a-zA-Z\s]+$/;

        const errors: validationErrors = {
            name: name.trim().length === 0 || !nameRegex.test(name.trim()),
            email: !emailRegex.test(email.trim()),
            message: message.trim().length === 0,
        };

        setValidationErrors(errors);

        const isValid = Object.values(errors).every((error) => !error);

        if (!isValid) return;

        if (!recaptchaToken) {
            error("Please complete the reCAPTCHA verification.");
            return;
        }

        setLoading(true);
        const apiService = new APICallService(CONTACTUS, formData);
        const response = await apiService.callAPI();

        if (response) {
            success("Contact details submitted successfully!");
            setFormData(initialState);
            setValidationErrors({
                name: false,
                email: false,
                message: false,
            });
            setRecaptchaToken(null);
            if (recaptchaWidgetId.current !== null && (window as any).grecaptcha) {
                (window as any).grecaptcha.reset(recaptchaWidgetId.current);
            }
        }
        setLoading(false);
    };

    const renderFAQItems = (faqs: FAQItem[], accordionId: string, tabId: string) => {
        if (faqLoading) {
            return <div className="text-center p-5">Loading FAQs...</div>;
        }

        if (faqs.length === 0) {
            return <div className="text-center p-5">No FAQs available.</div>;
        }

        return faqs.map((faq, index) => {
            const itemNumber = String(index + 1).padStart(2, "0");
            const headingId = `accordion-heading-${accordionId}-${index + 1}`;
            const collapseId = `accordion-collapse-${accordionId}-${index + 1}`;
            const isFirstItem = index === 0;
            const uniqueKey = `${accordionId}-${faq.title}-${index}`;

            return (
                <div key={uniqueKey} className="card accordion-item">
                    <div className="card-header d-flex align-items-center gap-5" id={headingId}>
                        <p className="fs-18 fw-normal text-secondary mb-0">{itemNumber}</p>
                        <button
                            className={isFirstItem ? "" : "collapsed"}
                            data-bs-toggle="collapse"
                            data-bs-target={`#${collapseId}`}
                            aria-expanded={isFirstItem ? "true" : "false"}
                            aria-controls={collapseId}
                        >
                            {faq.title}
                        </button>
                    </div>
                    <div
                        id={collapseId}
                        className={`collapse ${isFirstItem ? "show" : ""}`}
                        aria-labelledby={headingId}
                        data-bs-parent={`#accordion-${accordionId}`}
                    >
                        <div className="card-body ps-lg-13">
                            <div className="fs-18 fw-medium mb-0" dangerouslySetInnerHTML={{__html: faq.content}} />
                        </div>
                    </div>
                </div>
            );
        });
    };

    return (
        <>
            <div id="home" className="main-hero-sec wrapper overflow-hidden bg-soft-primary">
                <div className="container pt-10 pt-lg-6 pb-6 pb-lg-8">
                    <div className="row gy-8 gy-lg-10 align-items-center">
                        <div className="col-lg-6 text-center text-lg-start">
                            <div className="">
                                <h1 className="fs-46 fw-bolder text-capitalize text-mine-shaft mb-6 main-ease-animator1">
                                    Connecting people, goods and spare vehicle capacity through sustainable action
                                </h1>
                                <p className="fs-20 fw-medium text-mine-shaft mb-0 main-ease-animator2">
                                    Schedule, send, and track—all in one place. We make delivery simple, secure, and
                                    stress-free from start to finish.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-6 text-center">
                            <img
                                src={Main_img}
                                className="img-fluid main-ease-animator1"
                                width="569"
                                height="569"
                                alt=""
                                loading="lazy"
                            />
                        </div>
                    </div>
                </div>

                {/* App Download Split Section - Full-width dedicated strip with distinct background */}
                <div className="app-download-split-section">
                    <div className="container py-3 py-sm-4 py-lg-5">
                        <div className="row align-items-center gy-3 gy-sm-4 gy-lg-0">
                            {/* Left: User App */}
                            <div className="col-lg-5 text-center text-lg-start">
                                <div className="d-flex flex-column flex-sm-row align-items-center justify-content-center justify-content-lg-start gap-2 gap-xl-3">
                                    <div className="app-label-tag">
                                        <span className="app-label-icon">
                                            <svg
                                                width="17"
                                                height="17"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2.2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            >
                                                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                                                <circle cx="12" cy="7" r="4" />
                                            </svg>
                                        </span>
                                        <div className="app-label-text">
                                            <span className="app-label-title">User App</span>
                                            <span className="app-label-sub">Send & Track</span>
                                        </div>
                                    </div>
                                    <div className="app-store-btns">
                                        <a
                                            href={CUSTOMER_GOOGLE_PLAY_URL}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="store-btn"
                                        >
                                            <img
                                                src={GooglePlaySVG}
                                                width={155}
                                                height={46}
                                                alt="Google Play"
                                            />
                                        </a>
                                        <a
                                            href={CUSTOMER_APP_STORE_URL}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="store-btn"
                                        >
                                            <img
                                                src={AppStoreSvg}
                                                width={144}
                                                height={46}
                                                alt="App Store"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>

                            {/* Center: Hitch Logo */}
                            <div className="col-lg-2 text-center py-1 py-lg-0">
                                <div className="app-download-logo-wrap">
                                    <img
                                        src={LogoDark}
                                        alt="Hitch Logo"
                                        width={132}
                                        height={42}
                                        className="img-fluid"
                                    />
                                </div>
                            </div>

                            {/* Right: Driver App */}
                            <div className="col-lg-5 text-center text-lg-end">
                                <div className="d-flex flex-column flex-sm-row align-items-center justify-content-center justify-content-lg-end gap-2 gap-xl-3">
                                    <div className="app-label-tag">
                                        <span className="app-label-icon">
                                            <svg
                                                width="17"
                                                height="17"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2.2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            >
                                                <circle cx="12" cy="12" r="10" />
                                                <circle cx="12" cy="12" r="3" />
                                                <line x1="12" y1="2" x2="12" y2="9" />
                                                <line x1="4.93" y1="19.07" x2="9.88" y2="14.12" />
                                                <line x1="19.07" y1="19.07" x2="14.12" y2="14.12" />
                                            </svg>
                                        </span>
                                        <div className="app-label-text">
                                            <span className="app-label-title">Driver App</span>
                                            <span className="app-label-sub">Deliver & Earn</span>
                                        </div>
                                    </div>
                                    <div className="app-store-btns">
                                        <a
                                            href={DRIVER_GOOGLE_PLAY_URL}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="store-btn"
                                        >
                                            <img
                                                src={GooglePlaySVG}
                                                width={155}
                                                height={46}
                                                alt="Google Play"
                                            />
                                        </a>
                                        <a
                                            href={DRIVER_APP_STORE_URL}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="store-btn"
                                        >
                                            <img
                                                src={AppStoreSvg}
                                                width={144}
                                                height={46}
                                                alt="App Store"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="wrapper section-padding">
                <div className="container">
                    <div className="text-center features">
                        <h2 className="fs-40 fw-bolder mb-8 mb-lg-10">How Hitch Works</h2>
                    </div>
                </div>
                <div className="container-xxl px-0">
                    <Swiper
                        slidesPerView={1}
                        spaceBetween={10}
                        loop={true}
                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: false,
                        }}
                        pagination={{
                            clickable: true,
                        }}
                        breakpoints={{
                            640: {
                                slidesPerView: 2,
                                spaceBetween: 20,
                            },
                            768: {
                                slidesPerView: 3,
                                spaceBetween: 40,
                            },
                            1024: {
                                slidesPerView: 3.3,
                                spaceBetween: 50,
                            },
                        }}
                        modules={[Autoplay]}
                        className="mySwiper"
                    >
                        {howItWorksSlides.map((slide) => (
                            <SwiperSlide key={slide.id}>
                                <div className="card border-0">
                                    <div className="card-body text-center p-lg-0">
                                        <img
                                            className="img-fluid mb-4 mb-lg-5"
                                            src={slide.image}
                                            width={303}
                                            height={286}
                                            alt={slide.title}
                                            loading="lazy"
                                        />
                                        <h3 className="fs-22 fw-bold mb-1">{slide.title}</h3>
                                        <p className="fs-16 fw-medium mb-0">{slide.desc}</p>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>

            <div id="features" className="wrapper section-padding bg-soft-zircon">
                <div className="container">
                    <h2 className="fs-50 fw-bolder text-center mb-5 main-ease-animator1">Features</h2>
                    <p className="fs-20 fw-medium text-center mb-10 mb-lg-12">
                        Combining customer convenience with driver efficiency for smarter deliveries.
                    </p>
                    <div className="row gy-4 gy-lg-12 gx-lg-10">
                        {FeaturesData.map((item) => (
                            <div key={item.id} className="col-md-6 col-xl-4 d-flex">
                                <div className="card br-20 align-items-center w-100">
                                    <div className="card-body text-center p-lg-10">
                                        <img
                                            alt={item.title}
                                            src={item.img}
                                            className="img-fluid mb-5 mb-lg-7"
                                            width="82"
                                            height="82"
                                            loading="lazy"
                                        />

                                        <h3 className="fs-34 fw-bolder mb-4 mb-lg-5 px-lg-4">{item.title}</h3>

                                        <p className="fs-18 fw-medium">{item.subtitle}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className="wrapper section-padding bg-cultured">
                <div className="container">
                    <h2 className="fs-40 fw-bolder text-center mb-10 mb-lg-11 main-ease-animator1">
                        Set your radius search & find jobs along your route
                    </h2>
                    <div className="d-flex justify-content-center text-center">
                        <img
                            className="img-fluid d-none d-md-block"
                            src={MapImg}
                            width={1206}
                            height={497}
                            alt=""
                            loading="lazy"
                        />
                        <img
                            className="img-fluid d-block d-md-none"
                            src={MapMobileImg}
                            width={335}
                            height={248}
                            alt=""
                            loading="lazy"
                        />
                    </div>
                </div>
            </div>
            <div className="wrapper section-padding " id="sec-app-download">
                <div className="container">
                    <div className="card br-20 bg-soft-primary overflow-hidden">
                        <div className="card-body pb-0 pb-md-0 pb-lg-0 p-md-10 p-lg-12">
                            <div className="row align-items-center gy-10">
                                <div className="col-xl-6 text-xl-start text-center">
                                    <h2 className="fs-50 fw-bolder text-capitalize text-mine-shaft mb-4 mb-lg-5 main-ease-animator1">
                                        Driver, Deliver & Earn on Your Schedule
                                    </h2>
                                    <p className="fs-20 fw-medium text-mine-shaft mb-8 mb-lg-10 main-ease-animator2 ">
                                        Flexible deliveries, reliable earnings. Join our driver network and provide
                                        hassle-free service on your schedule.
                                    </p>
                                    <div className="d-flex flex-wrap justify-content-center justify-content-xl-start gap-3 gap-md-4 mb-5 pb-md-10 pb-lg-12">
                                        <div>
                                            <a href={DRIVER_GOOGLE_PLAY_URL} target="_blank" rel="noopener noreferrer">
                                                <img
                                                    className="img-fluid main-ease-animator3"
                                                    src={GooglePlaySVG}
                                                    width={177}
                                                    height={55}
                                                    alt="Google Play"
                                                />
                                            </a>
                                        </div>
                                        <div>
                                            <a href={DRIVER_APP_STORE_URL} target="_blank" rel="noopener noreferrer">
                                                <img
                                                    className="img-fluid main-ease-animator3"
                                                    src={AppStoreSvg}
                                                    width={165}
                                                    height={55}
                                                    alt="App store"
                                                />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-6 text-center">
                                    <img
                                        className="img-fluid position-xl-absolute top-0 end-0 bottom-0"
                                        src={MobileView}
                                        width={584}
                                        height={461}
                                        alt=""
                                        loading="lazy"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="wrapper section-padding carbon-credits-sec">
                <div className="container">
                    <div className="col-lg-10 mx-auto text-center mb-6 mb-lg-7">
                        <h2 className="fs-50 fw-bolder text-capitalize text-mine-shaft mb-4 mb-lg-5 main-ease-animator1">
                            Carbon Credits That Reward Smarter Journeys
                        </h2>
                        <p className="fs-24 fw-medium text-mine-shaft mb-0 main-ease-animator2">
                            At Hitch, every delivery helps reduce unnecessary trips on Irish roads. When a driver
                            completes a job that replaces another user’s separate journey, they earn 1 Carbon Credit for
                            every kilometre saved.
                        </p>
                    </div>
                    <div className="row justify-content-center gy-5 gx-lg-10 mb-lg-13">
                        <div className="col-md-6 col-xl-4 d-flex">
                            <div className="card br-20 w-100">
                                <div className="card-body px-lg-6 py-lg-9">
                                    <div className="row align-items-center gy-4">
                                        <div className="col-lg-auto">
                                            <img
                                                className="img-fluid"
                                                src={EmissionSvg}
                                                width={80}
                                                height={80}
                                                alt=""
                                                loading="lazy"
                                            />
                                        </div>
                                        <div className="col-lg">
                                            <p className="fs-18 fw-medium mb-0">
                                                Hitch uses engine size and distance to calculate the emissions saved.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-xl-4 d-flex">
                            <div className="card br-20 w-100">
                                <div className="card-body px-lg-6 py-lg-9">
                                    <div className="row align-items-center gy-4">
                                        <div className="col-lg-auto">
                                            <img
                                                className="img-fluid"
                                                src={CarbonMeterSvg}
                                                width={80}
                                                height={80}
                                                alt=""
                                                loading="lazy"
                                            />
                                        </div>
                                        <div className="col-lg">
                                            <p className="fs-18 fw-medium mb-0">
                                                Drivers automatically earn Carbon Credits for every kilometre they help
                                                to offset.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-xl-4 d-flex">
                            <div className="card br-20 w-100">
                                <div className="card-body px-lg-6 py-lg-9">
                                    <div className="row align-items-center gy-4">
                                        <div className="col-lg-auto">
                                            <img
                                                className="img-fluid"
                                                src={TravelReductionSvg}
                                                width={80}
                                                height={80}
                                                alt=""
                                                loading="lazy"
                                            />
                                        </div>
                                        <div className="col-lg">
                                            <p className="fs-18 fw-medium mb-0">
                                                These credits reflect real, measurable reductions in duplicated travel.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="about-us" className="wrapper section-padding bg-light-gray">
                <div className="container py-md-6 py-lg-10">
                    <div className="row align-items-center gy-5">
                        <div className="col-lg-6 text-center text-lg-start">
                            <h2 className="fs-50 fw-bolder text-capitalize text-mine-shaft text-center text-lg-start mb-4 mb-lg-5 main-ease-animator1">
                                About Us
                            </h2>
                            <p className="fs-20 fw-medium text-mine-shaft mb-4 mb-lg-5 main-ease-animator2">
                                Hitch is an innovative delivery platform designed to connect customers and drivers
                                seamlessly. Customers can easily post their product delivery requests, and drivers can
                                accept jobs that match their routes saving time, fuel, and effort.
                            </p>
                            <p className="fs-20 fw-medium text-mine-shaft mb-0 main-ease-animator2">
                                Our platform makes every trip more productive while providing customers with fast,
                                affordable, and reliable delivery options. Whether it’s a small parcel or a larger
                                shipment, Hitch ensures smooth and secure transportation with just a few taps.
                            </p>
                            <div className="mt-8 mt-lg-10">
                                <a
                                    href="#sec-app-download"
                                    onClick={(e) => handleScrollToSection(e, "sec-app-download")}
                                    className="btn btn-primary d-inline-flex align-items-center gap-2 px-7 px-md-8 px-lg-11"
                                >
                                    Download Now <img src={ArrowRight} width={20} height={20} alt="" loading="lazy" />{" "}
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-6 text-center order-lg-first">
                            <img className="img-fluid" src={AboutImg} width={540} height={450} alt="" loading="lazy" />
                        </div>
                    </div>
                </div>
            </div>
            <div
                id="register-interest"
                className="wrapper section-padding position-relative bg-cultured register-interest-sec z-0"
            >
                <div className="container">
                    <div className="row align-items-lg-start gy-8 gx-xl-14">
                        <div className="col-lg-5">
                            <h2 className="fs-50 fw-bolder text-dark-primary mb-3 main-ease-animator1">
                                Register Your <span className="underline-3 style-3 green">Interest</span>
                            </h2>
                            <h5 className="fs-22 fw-bold text-dark-primary mb-4 mb-lg-5 main-ease-animator2">
                                Calling All Drivers!
                            </h5>
                            <p className="fs-22 fw-medium text-dark-primary mb-0">
                                Interested in earning more on your travels but don&apos;t have the correct insurance?
                                Register your interest today and we&apos;ll let you know when we expand!
                            </p>
                        </div>
                        <div className="col-lg-7">
                            <div className="card bg-primary br-30">
                                <div className="card-body p-md-6 p-lg-8">
                                    <Form
                                        className="register-interest-form"
                                        onSubmit={handleRegisterInterestSubmit}
                                        noValidate
                                    >
                                        <div className="row gy-3 gy-lg-4">
                                            <div className="col-md-6">
                                                <Form.Group controlId="registerInterestFullName">
                                                    <Form.Label className="text-white">Full Name</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        className={clsx(
                                                            "form-control",
                                                            registerInterestErrors.fullName ? "border-danger" : ""
                                                        )}
                                                        placeholder="John Doe"
                                                        value={registerInterestData.fullName}
                                                        onChange={(e) =>
                                                            handleRegisterInterestChange(e.target.value, "fullName")
                                                        }
                                                        disabled={registerInterestLoading}
                                                        autoComplete="name"
                                                    />
                                                </Form.Group>
                                            </div>
                                            <div className="col-md-6">
                                                <Form.Group controlId="registerInterestEmail">
                                                    <Form.Label className="text-white">Email</Form.Label>
                                                    <Form.Control
                                                        type="email"
                                                        className={clsx(
                                                            "form-control",
                                                            registerInterestErrors.email ? "border-danger" : ""
                                                        )}
                                                        placeholder="john@mail.com"
                                                        value={registerInterestData.email}
                                                        onChange={(e) =>
                                                            handleRegisterInterestChange(e.target.value, "email")
                                                        }
                                                        disabled={registerInterestLoading}
                                                        autoComplete="email"
                                                    />
                                                </Form.Group>
                                            </div>
                                            <div className="col-md-6">
                                                <Form.Group controlId="registerInterestPhone">
                                                    <Form.Label className="text-white">Phone Number</Form.Label>
                                                    <PhoneInputWhite
                                                        id="registerInterestPhone"
                                                        value={registerInterestData.phone}
                                                        onChange={handleRegisterInterestPhoneChange}
                                                        hasError={registerInterestErrors.phone}
                                                        disabled={registerInterestLoading}
                                                    />
                                                </Form.Group>
                                            </div>
                                            <div className="col-md-6">
                                                <Form.Group controlId="registerInterestDob">
                                                    <Form.Label className="text-white">Date of Birth</Form.Label>
                                                    <Form.Control
                                                        type="date"
                                                        className={clsx(
                                                            "form-control",
                                                            registerInterestErrors.dateOfBirth ? "border-danger" : ""
                                                        )}
                                                        value={registerInterestData.dateOfBirth}
                                                        onChange={(e) =>
                                                            handleRegisterInterestChange(e.target.value, "dateOfBirth")
                                                        }
                                                        disabled={registerInterestLoading}
                                                        max={new Date().toISOString().split("T")[0]}
                                                    />
                                                </Form.Group>
                                            </div>
                                            <div className="col-md-6">
                                                <Form.Group controlId="registerInterestCounty">
                                                    <Form.Label className="text-white">County</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        className={clsx(
                                                            "form-control",
                                                            registerInterestErrors.county ? "border-danger" : ""
                                                        )}
                                                        placeholder="e.g. Donegal"
                                                        value={registerInterestData.county}
                                                        onChange={(e) =>
                                                            handleRegisterInterestChange(e.target.value, "county")
                                                        }
                                                        disabled={registerInterestLoading}
                                                        autoComplete="address-level1"
                                                    />
                                                </Form.Group>
                                            </div>
                                            <div className="col-md-6">
                                                <Form.Group controlId="registerInterestOccupation">
                                                    <Form.Label className="text-white">Occupation</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        className={clsx(
                                                            "form-control",
                                                            registerInterestErrors.occupation ? "border-danger" : ""
                                                        )}
                                                        placeholder="e.g. Delivery Driver"
                                                        value={registerInterestData.occupation}
                                                        onChange={(e) =>
                                                            handleRegisterInterestChange(e.target.value, "occupation")
                                                        }
                                                        disabled={registerInterestLoading}
                                                        autoComplete="organization-title"
                                                    />
                                                </Form.Group>
                                            </div>
                                            <div className="col-12">
                                                <Form.Group controlId="registerInterestInsurance">
                                                    <Form.Label className="text-white">
                                                        Do you have commercial or private insurance?
                                                    </Form.Label>
                                                    <CustomSelectWhite
                                                        id="registerInterestInsurance"
                                                        value={registerInterestData.insurance}
                                                        onChange={(value) =>
                                                            handleRegisterInterestChange(value, "insurance")
                                                        }
                                                        options={insuranceOptions}
                                                        hasError={registerInterestErrors.insurance}
                                                        disabled={registerInterestLoading}
                                                    />
                                                </Form.Group>
                                            </div>
                                            <div className="col-12">
                                                <Form.Group controlId="registerInterestAdditionalInfo">
                                                    <Form.Label className="text-white">Additional Info</Form.Label>
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={3}
                                                        className="form-control"
                                                        placeholder="Please do not include any sensitive personal information, such as health or medical details."
                                                        value={registerInterestData.additionalInfo}
                                                        onChange={(e) =>
                                                            handleRegisterInterestChange(
                                                                e.target.value,
                                                                "additionalInfo"
                                                            )
                                                        }
                                                        disabled={registerInterestLoading}
                                                    />
                                                </Form.Group>
                                            </div>
                                            <div className="col-12 mt-2">
                                                <Button
                                                    type="submit"
                                                    className="btn btn-white py-3 py-lg-4 w-100"
                                                    disabled={registerInterestLoading}
                                                >
                                                    {registerInterestLoading ? "Submitting..." : "Submit"}
                                                </Button>
                                            </div>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className="wrapper section-padding bg-soft-orange">
                <div className="container">
                    <h2 className="fs-50 fw-bolder text-center mb-5 main-ease-animator1">
                        Real Stories from Satisfied Customers
                    </h2>
                    <p className="fs-20 fw-medium text-center mb-10 mb-lg-12">
                        See how our customers are happy with their seamless deliveries.
                    </p>
                    <Swiper
                        slidesPerView={1}
                        spaceBetween={20}
                        loop={true}
                        autoplay={{
                            delay: 3500,
                            disableOnInteraction: false,
                        }}
                        pagination={{
                            clickable: true,
                        }}
                        breakpoints={{
                            768: {
                                slidesPerView: 1,
                                spaceBetween: 20,
                            },
                            1200: {
                                slidesPerView: 2,
                                spaceBetween: 30,
                            },
                        }}
                        modules={[Autoplay]}
                        className="testimonial-swiper"
                    >
                        {TestimonialData.map((testimonial, idx) => (
                            <SwiperSlide key={testimonial.name}>
                                <div className="card br-20 w-100">
                                    <div className="card-body p-lg-10">
                                        <div className="row align-items-center gy-4">
                                            <div className="col-lg-4 text-center">
                                                <img
                                                    className="img-fluid rounded-circle mb-4"
                                                    src={testimonial.image}
                                                    width={120}
                                                    height={120}
                                                    alt={testimonial.name}
                                                    loading="lazy"
                                                />
                                                <h3 className="fs-30 fw-fw-bold mb-0">{testimonial.name}</h3>
                                            </div>
                                            <div className="col-lg text-lg-start text-center">
                                                <div className="d-flex align-items-center justify-content-center justify-content-lg-start gap-1 mb-5 mb-lg-6">
                                                    {[...Array(testimonial.rating)].map((_, i) => (
                                                        <img key={i} src={StarIcon} width={24} height={24} alt="star" />
                                                    ))}
                                                </div>
                                                <p className="fs-18 fw-medium mb-0">{testimonial.review}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div> */}
            <div className="wrapper section-padding bg-soft-orange">
                <div className="container">
                    <h2 className="fs-50 fw-bolder text-center mb-5 main-ease-animator1 col-xl-9 mx-auto">
                        Winner of Sustainability & Green Award at Donegal LEO Awards 2025
                    </h2>
                </div>
            </div>
            <div id="faq" className="wrapper section-padding">
                <div className="container">
                    <div className="row gy-5">
                        <div className="col-lg-5">
                            <h2 className="fs-50 fw-bolder text-center text-lg-start mb-5 main-ease-animator1">
                                <span className="underline-3 style-3 green">Frequently</span> <br className="br" />{" "}
                                Asked Questions
                            </h2>
                            <p className="fs-20 fw-normal text-secondary text-center text-lg-start">
                                Clear answers to the most common questions about Hitch and how our app can support you.{" "}
                            </p>
                        </div>
                        <div className="col-12 order-lg-first text-center">
                            <ul
                                className="nav nav-tabs d-inline-flex gap-6 gap-md-10 gap-lg-15 px-4 mb-lg-5 faq-tab"
                                id="faqTabs"
                                role="tablist"
                            >
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link active"
                                        id="faq-1-tab"
                                        data-bs-toggle="tab"
                                        data-bs-target="#faq-1"
                                        type="button"
                                        role="tab"
                                        aria-controls="faq-1"
                                        aria-selected="true"
                                    >
                                        Customer
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link"
                                        id="faq-2-tab"
                                        data-bs-toggle="tab"
                                        data-bs-target="#faq-2"
                                        type="button"
                                        role="tab"
                                        aria-controls="faq-2"
                                        aria-selected="false"
                                    >
                                        Driver
                                    </button>
                                </li>
                            </ul>
                        </div>

                        <div className="col-lg-7">
                            <div className="tab-content mt-0">
                                <div
                                    className="tab-pane fade show active"
                                    id="faq-1"
                                    role="tabpanel"
                                    aria-labelledby="faq-1-tab"
                                >
                                    <div className="max-h-lg-475px br-30">
                                        <div
                                            id="accordion-1"
                                            className="accordion-wrapper card border-dark-gray br-30 overflow-hidden"
                                        >
                                            {renderFAQItems(customerFAQs, "1", "faq-1")}
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="faq-2" role="tabpanel" aria-labelledby="faq-2-tab">
                                    <div className="max-h-lg-475px br-30">
                                        <div
                                            id="accordion-2"
                                            className="accordion-wrapper card border-dark-gray br-30 overflow-hidden"
                                        >
                                            {renderFAQItems(driverFAQs, "2", "faq-2")}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div></div>
                </div>
            </div>
            <div id="contact-us" className="wrapper section-padding position-relative bg-cultured contact-us-sec z-0">
                <div className="">
                    <div className="container">
                        <div className="row align-items-center gy-8 gx-xl-14">
                            <div className="col-lg-6">
                                <img
                                    className="img-fluid mb-8 mb-md-9  mb-lg-11"
                                    src={ChatIcon}
                                    width={86}
                                    height={86}
                                    alt=""
                                    loading="lazy"
                                />
                                <h2 className="fs-50 fw-bolder text-dark-primary mb-3 main-ease-animator1">
                                    Let’s <span className="underline-3 style-3 green">Connect</span>
                                </h2>
                                <p className="fs-22 fw-medium text-dark-primary mb-8 mb-md-10 mb-lg-12">
                                    We’d love to hear from you! If you have any questions, suggestions, or feedback,
                                    please reach out to us.
                                </p>
                                <div className="d-flex align-items-center gap-3">
                                    <img
                                        className="img-fluid flex-shrink-0"
                                        src={Mail}
                                        width={46}
                                        height={46}
                                        alt=""
                                        loading="lazy"
                                    />
                                    <Link
                                        to="mailto:support@hitchnetworking.com"
                                        className="fs-22 fw-normal text-dark-primary"
                                    >
                                        support@hitchnetworking.com
                                    </Link>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="card bg-primary br-30">
                                    <div className="card-body p-md-7 p-lg-10">
                                        <Form onSubmit={handleSubmit} noValidate>
                                            <div className="row gy-4 gy-lg-7">
                                                <div className="col-12">
                                                    <Form.Group controlId="footerContactName">
                                                        <Form.Label className="text-white">Name</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            className={clsx(
                                                                "form-control",
                                                                validationErrors.name ? "border-danger" : ""
                                                            )}
                                                            placeholder="John Doe"
                                                            onChange={(e) => handleInputChange(e.target.value, "name")}
                                                            disabled={loading}
                                                            value={formData.name}
                                                            autoComplete="off"
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-12">
                                                    <Form.Group controlId="footerContactEmail">
                                                        <Form.Label className="text-white">Email</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            className={clsx(
                                                                "form-control",
                                                                validationErrors.email ? "border-danger" : ""
                                                            )}
                                                            placeholder="john@mail.com"
                                                            onChange={(e) => handleInputChange(e.target.value, "email")}
                                                            disabled={loading}
                                                            value={formData.email}
                                                            autoComplete="off"
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-12">
                                                    <Form.Group controlId="footerContactMessage">
                                                        <Form.Label className="text-white">Message</Form.Label>
                                                        <Form.Control
                                                            as="textarea"
                                                            rows={4}
                                                            className={clsx(
                                                                "form-control",
                                                                validationErrors.message ? "border-danger" : ""
                                                            )}
                                                            placeholder="Hello there"
                                                            onChange={(e) =>
                                                                handleInputChange(e.target.value, "message")
                                                            }
                                                            disabled={loading}
                                                            value={formData.message}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-12">
                                                    <div ref={recaptchaRef}></div>
                                                </div>
                                                <div className="col-12 mt-7">
                                                    <Button
                                                        type="submit"
                                                        className="btn btn-white py-lg-7 w-100"
                                                        disabled={loading}
                                                    >
                                                        Submit
                                                    </Button>
                                                </div>
                                            </div>
                                        </Form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Home;
